import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/Button';
import { useJobs } from '../../contexts/JobContext';

export const RejoinButton: React.FC = () => {
  const { jobs } = useJobs();
  const navigate = useNavigate();
  const active = React.useMemo(()=> jobs.filter(j => j.status !== 'completed' && j.status !== 'failed').sort((a,b)=>(b.updated_at||0)-(a.updated_at||0))[0], [jobs]);

  if (!active) return null;

  const onClick = () => {
    // Prefer resume_url, else try anchors to route
    if (active.resume_url) {
      navigate(active.resume_url);
    } else if (active.anchors?.candidate_id && active.anchors?.requirement_id) {
      navigate(`/candidates/${active.anchors.candidate_id}/analysis/${active.anchors.requirement_id}`);
    } else if (active.anchors?.candidate_id) {
      navigate(`/candidates/${active.anchors.candidate_id}`);
    }
  };

  return (
    <Button variant="ghost" size="sm" onClick={onClick} title="Rejoin your last job">
      Rejoin
    </Button>
  );
};

export default RejoinButton;


